import { render } from "./CatMonedaView.vue?vue&type=template&id=16f6e5c4&scoped=true"
import script from "./CatMonedaView.vue?vue&type=script&lang=js"
export * from "./CatMonedaView.vue?vue&type=script&lang=js"

import "./CatMonedaView.vue?vue&type=style&index=0&id=16f6e5c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f6e5c4"]])

export default __exports__